import { axiosInstance } from "@/configs/axiosConfig";

// Search Result API
export const getCompanyOptout = () => {
  return axiosInstance.get("/contacts");
};

// updateContactOptout Result API
export const updateContactOptout = (reqBody) => {
  return axiosInstance.post("/contacts", reqBody);
};

export const getOptoutLogs = () => {
  return axiosInstance.get("/dunsoptoutreport");
};

export const getContactOptoutLogs = () => {
  return axiosInstance.get("/contactoptoutreport");
};
